import BaseApp from "../BaseApp";

import RunnedAppsView from "./view/RunnedAppsView";
import RunnedAppModel from "./model/RunnedAppModel";
import RunnedAppsCollection from "./model/RunnedAppsCollection";
import "plugins/hasChild";


export default class RunnedApps extends BaseApp {
    onReady() {
        this.trayBarChannel = system.apps.channel("TrayBar");
        this.trayItemModel = this.trayBarChannel.add({
            sort: 5,
            icon: "runnedApps"
        });
        this.listenTo(this.trayItemModel, "click", this.onClickTrayItem.bind(this));

        this.collection = new RunnedAppsCollection();
        this.view = new RunnedAppsView({
            collection: this.collection
        });
        this.view.render();
        this.view.$el.appendTo(document.body);

        this.listenTo($(window), "click", this.onClickWindow.bind(this));

        this.listenTo(system.apps, "run", this.onRunApp.bind(this));

        this.listenTo(this.view, "showApp", this.onShowApp.bind(this));
        this.listenTo(this.view, "closeApp", this.onCloseApp.bind(this));
        this.listenTo(this.view, "minApp", this.onMinApp.bind(this));
    }

    onShowApp(runnedAppModel) {
        let app = runnedAppModel.get("app");
        app.show();
        this.view.$el.removeClass("show");
    }

    onMinApp(runnedAppModel) {
        let app = runnedAppModel.get("app");
        app.modal.min();
    }

    onCloseApp(runnedAppModel) {
        let app = runnedAppModel.get("app");

        if ( app.title === "Form2" ) {
            app.cancelFromAll();
        } else {
            app.destroy();
        }
    }

    onClickWindow(e) {
        let $target = $(e.target);

        if (
            this.view.$el.hasChild(e.target)
                || $target.hasClass("RunnedAppItemView--close")
                || $target.parents(".TrayBarView").length
        ) {
            return;
        }

        this.view.$el.removeClass("show");
    }

    onRunApp(app) {
        if ( !app.modal ) {
            return;
        }

        let runnedAppModel = new RunnedAppModel({
            title: app.modal.title,
            app
        });
        this.collection.add(runnedAppModel);
        this.trayItemModel.set("count", this.collection.length);

        this.listenTo(app, "destroy", this.onDestroyApp.bind(this, runnedAppModel));
    }

    onClickTrayItem() {
        if ( !this.collection.length ) {
            return;
        }

        this.view.$el.toggleClass("show");
    }

    onDestroyApp(runnedAppModel) {
        this.collection.remove(runnedAppModel);
        this.trayItemModel.set("count", this.collection.length);

        if ( !this.collection.length ) {
            this.view.$el.removeClass("show");
        }
    }
}